/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon20Regular = forwardRef('ArrowRoundSyncForwardIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.642 3.645a6.499 6.499 0 0 1 6.837 2.86H13a.75.75 0 0 0 0 1.5h4.25a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-1.5 0v2.583A7.999 7.999 0 0 0 2.044 9.181a.75.75 0 0 0 1.492.154 6.499 6.499 0 0 1 5.106-5.69Z" }),
        React.createElement("path", { d: "M7.356 15.936a6.498 6.498 0 0 0 9.106-5.251.75.75 0 0 1 1.492.158A7.998 7.998 0 0 1 3.5 14.662v2.583a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75H7a.75.75 0 0 1 0 1.5H4.521a6.498 6.498 0 0 0 2.835 2.441Z" })));
});
